import React, { Component } from 'react';
import './New-Address.scss';
import InputMask from 'react-input-mask';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';


class NewAddress extends Component {
    constructor(props) {
        super(props);
        this.handleOnInput = this.handleOnInput.bind(this);
        this.buscaCEP = this.buscaCEP.bind(this);
        this.salvarEndereco = this.salvarEndereco.bind(this);

        this.state = {
            cepDistrital: this.props.cepDistrital,
            endereco: this.props.endereco,
            observacao: '',
            cepBusca: '',
            numeroEndereco: '',
            nomeEndereco: '',
            complementoEndereco: '',
            logradouroEndereco: '',
            bairroEndereco: '',
            exibeEndereco: false,
            mensagemErro: false,
            erroCEP: false

        }
        this.Configurations = new Configurations();

    }

    handleOnInput(e) {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }

    buscaCEP() {
        this.setState({ isLoadingBuscaCEP: true })
        axios.get(this.Configurations.apiBasePath + `/cep/${this.state.cepBusca}`).then(response => {
            this.setState({
                endereco: response.data.endereco,
                cepDistrital: response.data.endereco.logradouro === ''
            }, () => this.setState({ exibeEndereco: true, erroCEP: false, mensagemErro: false }))
        }).catch(err => {
            this.setState({ erroCEP: true, exibeEndereco: false })
        }).finally(() => this.setState({ isLoadingBuscaCEP: false }));
    }

    salvarEndereco() {
        const _nomeLocal = this.state.nomeEndereco ? this.state.nomeEndereco !== '' : false,
            _numero = this.state.numeroEndereco ? this.state.numeroEndereco !== '' : false,
            _logradouro = this.state.cepDistrital ? this.state.logradouroEndereco !== '' : true,
            _bairro = this.state.cepDistrital ? this.state.bairroEndereco !== '' : true,
            _valido = _nomeLocal * _numero * _logradouro * _bairro;

        const _endereco = this.state.cepDistrital ? (
            {
                ...this.state.endereco,
                logradouro: this.state.logradouroEndereco,
                bairro: this.state.bairroEndereco,
                titulo: this.state.nomeEndereco,
                numero: this.state.numeroEndereco,
                complemento: this.state.complementoEndereco,
                principal: false
            }
        ) : (
                {
                    ...this.state.endereco,
                    titulo: this.state.nomeEndereco,
                    numero: this.state.numeroEndereco,
                    complemento: this.state.complementoEndereco,
                    principal: false
                }
            );

        if (_valido) {

            this.setState({
                endereco: _endereco
            }, () => {
                this.props.salvarEndereco(this.state.endereco);
                this.setState({ mensagemErro: false })
            })
        } else this.setState({ mensagemErro: true })
    }

    render() {
        return (
            <div className="row no-gutters new-address">
                <div className="col-12 px-3">
                    <div className="row align-items-end">
                        <div className="col-12 col-lg-6 py-3">
                            <label>Nome do novo local <sup>*</sup></label>
                            <input name="nomeEndereco" className="form-control" onChange={this.handleOnInput} value={this.state.nomeEndereco} />
                        </div>
                        <div className="col-12 col-lg-3 py-3">
                            <label>CEP <sup>*</sup></label>
                            <InputMask
                                autoComplete="off"
                                name="cepBusca"
                                type="tel"
                                className="form-control"
                                maskChar="_"
                                id="cep"
                                mask="99999-999"
                                placeholder="00000-000"
                                value={this.state.cepBusca}
                                onChange={this.handleOnInput}
                            />
                        </div>
                        <div className="col-6 col-lg-3 mb-3 pb-1">
                            {this.state.isLoadingBuscaCEP ? (
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                </div>
                            ) : (
                                    <button disabled={this.state.cepBusca.indexOf("_") >= 0 || this.state.cepBusca === ""} onClick={this.buscaCEP} className="btn btn-outline-info">buscar CEP</button>
                                )}
                        </div>
                        {this.state.erroCEP && (
                            <div className="offset-0 col-12 offset-lg-6 col-lg-6 py-2 text-left">
                                <small className="text-danger">CEP inválido.</small>
                            </div>
                        )}
                        <div className="col-12 py-2">
                            {this.state.exibeEndereco && (
                                <div className={`row my-3 ${this.state.isLoadingBuscaCEP ? 'end-opacity' : ''}`}>
                                    <div className="col-12 py-3">
                                        <div className="row">
                                            <div className="col-3 text-truncate">
                                                <label>País</label>
                                                <div className="row">
                                                    <div className="col-12 informacoes-endereco">
                                                        {this.state.endereco.pais}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-5">
                                                <label>Cidade</label>
                                                <div className="row">
                                                    <div className="col-12 informacoes-endereco">
                                                        {this.state.endereco.cidade}, {this.state.endereco.uf}
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.cepDistrital ? (
                                                <div className="col-4">
                                                    <label htmlFor="bairroEndereco">Bairro <sup>*</sup></label>
                                                    <input onChange={this.handleOnInput} name="bairroEndereco" className="form-control" value={this.state.bairroEndereco} />
                                                </div>
                                            ) : (
                                                    <div className="col-4">
                                                        <label htmlFor="bairro">Bairro</label>
                                                        <div className="row">
                                                            <div className="col-12 informacoes-endereco">
                                                                {this.state.endereco.bairro}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="row py-2 align-items-center">
                                            {this.state.cepDistrital ? (
                                                <div className="col-5">
                                                    <label htmlFor="logradouroEndereco">Endereço <sup>*</sup></label>
                                                    <input onChange={this.handleOnInput} name="logradouroEndereco" className="form-control" value={this.state.logradouroEndereco} />
                                                </div>
                                            ) : (
                                                    <div className="col-5">
                                                        <label htmlFor="endereco">Endereço </label>
                                                        <div className="row">
                                                            <div className="col-12 informacoes-endereco">
                                                                {this.state.endereco.logradouro}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                            <div className="offset-1 col-2" id="PopNumero">
                                                <label htmlFor="numeroEndereco">Número <sup>*</sup></label>
                                                <input onChange={this.handleOnInput} name="numeroEndereco" id={1} maxLength="7" className="form-control" value={this.state.numeroEndereco} />
                                            </div>
                                            <div className="col-3">
                                                <label htmlFor="complementoEndereco">Complemento</label>
                                                <input onChange={this.handleOnInput} name="complementoEndereco" id={2} type="text" className="form-control" value={this.state.complementoEndereco} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 pt-5 py-2 text-center">
                                        {this.props.isLoadingEndereco ? (
                                            <div className="spinner-border text-primary" role="status" />
                                        ) : (
                                                <button onClick={this.salvarEndereco} className="btn btn-outline-success">salvar endereço</button>
                                            )}
                                    </div>
                                    <div className="col-12 py-2 text-center">
                                        {this.state.mensagemErro && (
                                            <small className="text-danger">Por favor, preencha todos os campos obrigatórios.</small>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default NewAddress;
